import { z } from 'zod';

/**
 * Assign (or claim) a client's current-period monthly close to a reviewer
 * (backlog B1). Omit `reviewerId` to claim it for yourself; set it to assign to
 * a specific reviewer. `force` overrides the capacity guard — the platform-admin
 * escape hatch, mirroring the monthly-close sign-off override.
 */
export const assignReviewerSchema = z.object({
  organizationId: z.string().min(1),
  reviewerId: z.string().min(1).optional(),
  force: z.boolean().optional(),
});

export type AssignReviewerInput = z.infer<typeof assignReviewerSchema>;

/**
 * Cross-client bulk sign-off (backlog B5). Sign off many review-ready closes at
 * once; each still passes the A1 open-items guard (no bulk force-override).
 */
export const bulkSignoffSchema = z.object({
  closeIds: z.array(z.string().min(1)).min(1).max(100),
});

export type BulkSignoffInput = z.infer<typeof bulkSignoffSchema>;
